import { render, staticRenderFns } from "./chooseGame.vue?vue&type=template&id=13e56fba&scoped=true"
import script from "./chooseGame.vue?vue&type=script&lang=js"
export * from "./chooseGame.vue?vue&type=script&lang=js"
import style0 from "./chooseGame.vue?vue&type=style&index=0&id=13e56fba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e56fba",
  null
  
)

export default component.exports